import { Badge, Stack, Typography } from '@mui/material'
import { LabelMasterStatusEnum } from '@ulysses-inc/harami_api_client'
import { labelMasterStatusText } from 'src/features/labelMaster/labelMasterStatus'

type Props = {
  status: LabelMasterStatusEnum
}

export const StatusBadge = ({ status }: Props) => {
  const label = labelMasterStatusText[status]
  const badgeColor =
    status === LabelMasterStatusEnum.VALID ? 'success' : 'secondary'
  const textColor =
    status === LabelMasterStatusEnum.VALID ? 'success.main' : 'text.secondary'
  const fontWeight = status === LabelMasterStatusEnum.VALID ? 'bold' : 'normal'

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Badge color={badgeColor} variant="dot" />
      <Typography variant="body2" color={textColor} fontWeight={fontWeight}>
        {label}
      </Typography>
    </Stack>
  )
}
